import * as React from 'react';
import Image from 'next/image';

type IAboutProps = object;

const About: React.FunctionComponent<IAboutProps> = () => {
  return (
    <section id='about' className='pb-20 lg:pb-25 xl:pb-30 overflow-hidden pt-30'>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 xl:px-0'>
        {/* Header added here */}
        <h1 className='text-black text-4xl xl:text-hero font-bold mb-10 pl-5'>AI Conversations </h1>
        <h4 className='text-black text-lg font-medium mb-10 pl-5'>
          Over 65% of website visitors bounce. Our AI chatbot is your 24x7 sales co-pilot
        </h4>

        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left hidden md:block md:w-1/2'>
            <Image src='/images/products/chatbot/chatbot_dashboard.png' alt='About' width={600} height={400} />
          </div>
          <div className='animate_right md:w-1/2'>
            <h4 className='text-black font-medium uppercase'>Never lose a prospect</h4>
            <h2 className='relative font-bold text-black text-3xl xl:text-hero mb-6'>
              Grow your leads with an{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg before:-z-1'>
                AI SDR.
              </span>
            </h2>
            <p>Completely configurable:</p>
            <ul className='list-disc list-inside'>
              <li>See buyer interactions on your website</li>
              <li>Promote the latest webinar </li>
              <li>Provide buyers with starter prompts to kick things off</li>
              <li>One line to install</li>
            </ul>
          </div>
        </div>
      </div>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 2xl:px-0 pt-30'>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left md:w-1/2'>
            <h4 className='text-black font-medium uppercase'>Customize Appearance</h4>
            <h2 className='relative font-bold text-black text-3xl xl:text-hero mb-6'>
              Increase engagement with{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg2 before:-z-1'>
                AI Offers
              </span>
            </h2>
            <p>Customized based on content:</p>
            <ul className='list-disc list-inside'>
              <li>Targeted AI offers based on content.</li>
              <li>Auto detect UTM and generated</li>
              <li>Increase your conversions in a week</li>
              <li>Stats on impressions and conversions</li>
            </ul>
          </div>
          <div className='animate_right hidden md:block md:w-1/2'>
            <Image src='/images/products/chatbot/AIOffers.png' alt='About' width={600} height={400} />
          </div>
        </div>
      </div>
      <div className='mx-auto max-w-c-1235 px-4 md:px-8 xl:px-0 pt-30'>
        <div className='flex items-center gap-8 lg:gap-32.5'>
          <div className='animate_left hidden md:block md:w-1/2'>
            <Image src='/images/products/chatbot/chatbot_customise.png' alt='About' width={600} height={400} />
          </div>
          <div className='animate_right md:w-1/2'>
            <h4 className='text-black font-medium uppercase'>Multiple bots</h4>
            <h2 className='relative font-bold text-black text-3xl xl:text-hero mb-6'>
              Specific bots based on{' '}
              <span className='inline-block relative before:absolute before:bottom-2.5 before:left-0 before:w-full before:h-3 before:bg-titlebg before:-z-1'>
                Page content
              </span>
            </h2>
            <p>Customize each chatbot based on the page:</p>
            <ul className='list-disc list-inside'>
              <li>Create bots specificall for channel or partner pages.</li>
              <li>Auto detects pages and activates</li>
              <li>Train using specific data</li>
              <li>Auto launch on startup</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
